import { ComponentInterface } from 'typings'
import { OptionType } from 'syf-component-library/ui/atoms/Select/typings'
import Icon from 'ui/atoms/Icon'
import {
  Subtext,
  StyledH2,
  StyledSelect,
  StyledTextfield,
  StyledCheckbox,
  StyledSelectContainer
} from 'pages/InfoRequestPage.styles'
import useCustomTranslation from 'hooks/useCustomTranslation'
import { Grid, GridHeading } from './RequestPage.styles'

const ContactInformation = ({
  formValues,
  handleOnChange,
  handleOnBlur
}: ComponentInterface): JSX.Element => {
  const t = useCustomTranslation('form.contact')

  return (
    <>
      <GridHeading>
        <StyledH2 style={{ maxWidth: '500px', width: '80vw' }}>
          {t('title')}
        </StyledH2>
      </GridHeading>
      <Subtext style={{ marginTop: 0 }}>{t('subtext')}</Subtext>
      <Grid>
        <StyledTextfield
          type="text"
          id="phone"
          name="phone"
          placeholder={t('phone')}
          error={formValues.errors.phone}
          value={formValues.phone}
          matchPattern={/^\d*$/}
          onChange={e =>
            handleOnChange('phone', (e.target as HTMLInputElement).value)
          }
          onBlur={() =>
            !formValues.hardOfHearing &&
            !formValues.phone &&
            handleOnBlur('phone')
          }
          autoComplete="tel"
          maxLength={10}
          errorIcon={Icon('error')}
          data-testid="phone"
        />
        <StyledSelectContainer>
          <StyledSelect
            id="phoneType"
            name="phoneType"
            placeholder={t('phoneType') || ''}
            options={[
              { label: t('phoneTypeOptions.home'), value: 'Home' },
              { label: t('phoneTypeOptions.mobile'), value: 'Mobile' },
              { label: t('phoneTypeOptions.business'), value: 'Business' }
            ]}
            errorIcon={Icon('error')}
            error={formValues.errors.phoneType}
            defaultOption={formValues.phoneType}
            onChange={(value: OptionType) => handleOnChange('phoneType', value)}
            onBlur={() =>
              formValues.phone &&
              !formValues.phoneType &&
              handleOnBlur('phoneType')
            }
            rightIconOpen={Icon('up')}
            rightIconClosed={Icon('down')}
            data-testid="phone-type"
          />
        </StyledSelectContainer>
      </Grid>
      <Grid>
        <StyledTextfield
          type="text"
          id="email"
          name="email"
          placeholder={t('email')}
          error={formValues.errors.emailAddress}
          value={formValues.emailAddress}
          onChange={e =>
            handleOnChange('emailAddress', (e.target as HTMLInputElement).value)
          }
          onBlur={() =>
            !formValues.emailAddress && handleOnBlur('emailAddress')
          }
          autoComplete="email"
          maxLength={70}
          errorIcon={Icon('error')}
          data-testid="email"
        />
        <StyledTextfield
          type="text"
          id="confirmEmail"
          name="confirmEmail"
          placeholder={t('confirmEmail')}
          error={formValues.errors.confirmEmail}
          value={formValues.confirmEmail}
          onChange={e =>
            handleOnChange('confirmEmail', (e.target as HTMLInputElement).value)
          }
          onBlur={() =>
            formValues.emailAddress &&
            !formValues.confirmEmail &&
            handleOnBlur('confirmEmail')
          }
          autoComplete="confirmEmail"
          maxLength={70}
          errorIcon={Icon('error')}
          data-testid="confirm-email"
        />
      </Grid>
      <Grid style={{ flexDirection: 'column' }}>
        <StyledCheckbox
          id="hardOfHearing"
          isChecked={formValues.hardOfHearing}
          onChange={() =>
            handleOnChange('hardOfHearing', !formValues.hardOfHearing)
          }
          data-testid="hearing"
        >
          {t('hardOfHearing')}
        </StyledCheckbox>
        <StyledCheckbox
          id="mailPreferred"
          isChecked={formValues.mailPreferred}
          isDisabled
          onChange={() =>
            handleOnChange('mailPreferred', !formValues.mailPreferred)
          }
          data-testid="mailPreferred"
        >
          {t('mailPreferred')}
        </StyledCheckbox>
      </Grid>
    </>
  )
}

export default ContactInformation
